import React from 'react';
import ecoForceIcon from './assets/EcoForceIcon.avif';
import './App.css';
import Banner from './components/Banner';
import HomeTextbox from './components/HomeTextbox';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import NextButton from './components/NextButton';
import { useNavigate } from 'react-router-dom';
import { PATH } from './constants';
import './style.css';
import ApiClient from './apisClient';
import { useEffect } from 'react';

// Define styled components
const HomeContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  height:'auto',
  overflow: 'hidden',
});

const IconContainer = styled('section')({
  justifyContent: 'center',
  marginTop: '10px',
  flex: 1,
  display: 'flex',
  height: 'auto', // Add this line
  overflow: 'hidden', // Add this 
});

const TextboxContainer = styled('section')({
  flex: 1,
  padding: '0 20px',
  height: 'auto', // Add this line
  overflow: 'hidden', // Add this 
});

const ButtonContainer = styled('section')({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const api = new ApiClient();
function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  //get user
  const user = JSON.parse(localStorage.getItem('user'));

  const iconSize = isMobile ? '50px' : '150px';
  const sso_id = localStorage.getItem('sso_id');

  useEffect(() => {
    const postUserProfile = async () => {
      if (localStorage.getItem('jwt_token')) {
        try {
          await api.post('/api/v1/users', {
            user_sso_id: sso_id || null,
            first_name: user?.First_Name || '',
            last_name: user?.Last_Name || '',
            email_id: user?.UserEmail || '',
            city: user?.City || null,
            role: user?.Role || null,
          });
        
        } catch (error) {
          console.error('Error creating user:', error);
          // Optionally, handle the error, e.g., show an error message to the user
        }
      }
    };

    postUserProfile();
  }, [navigate, sso_id, user]);


  return (
    <HomeContainer>
      <Banner />
      <IconContainer>
        <img 
          src={ecoForceIcon} 
          alt="EcoForce Icon" 
          style={{ width: iconSize, height: iconSize }} 
        />
      </IconContainer>
      <TextboxContainer>
        <HomeTextbox />
      </TextboxContainer>
      <ButtonContainer>
        <NextButton onClick={() => navigate(PATH.userProfileSelectionPath)} />
      </ButtonContainer>
    </HomeContainer>
  );
}

export default Home;